import { Tooltip, TooltipProps } from '@chakra-ui/react';
import { ReactNode, useState } from 'react';

interface ITooltipStandardProps extends TooltipProps {
	children: ReactNode;
	label: string;
	[key: string]: any;
}
export const TooltipStandard = ({
	children,
	label,
	...rest
}: ITooltipStandardProps) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Tooltip
			label={label}
			placement='top'
			bg={'gray.200'}
			color={'blue.800'}
			hasArrow={true}
			arrowSize={15}
			isOpen={isOpen}
			shouldWrapChildren={false}
			{...rest}
		>
			<span
				style={{
					display: 'flex',
				}}
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
			>
				{children}
			</span>
		</Tooltip>
	);
};
